import { FormInput, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useEffect } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TTicketAutoFinishRuleForm } from "./TicketAutoFinishRuleSchema";

const translationPath = "page.settings.crm.ticketAutoFinishRules.";

export const Minutes = memo(() => {
  const { t } = useTranslation();

  const { control, setValue } = useFormContext<TTicketAutoFinishRuleForm>();

  const finish = useWatch({
    name: "finish",
    control,
  });

  useEffect(() => {
    if (!finish) {
      setValue("minutes", "");
    }
  }, [setValue, finish]);

  return (
    <Grid item xs={12} sm={6}>
      <FormInput
        size="small"
        name="minutes"
        type="number"
        fullWidth
        disabled={!finish}
        label={t(translationPath + "minutes") || "Minutes"}
      />
    </Grid>
  );
});
